import React, { FC } from 'react';
import {
  isSolutionWithSubContent,
  SolutionAnswer,
  SolutionSubContent,
} from '../../../../../../config/api/models/Solutions';
import { useTranslation } from 'react-i18next';
import { StyledDivider, StyledQuestionTitle, TopLevelQuestionType, TypeTreeDivider } from './Atoms';
import { StudentSolutionSubContentAnswers } from './StudentSolutionSubContentAnswers';
import { preProcessLatex } from '../../../../helpers';
import { MathJax } from 'better-react-mathjax';
import ReactHtmlParser from 'react-html-parser';

type StudentSolutionSubContentProps = {
  subContent: SolutionSubContent[];
  level: number;
  typeTree: string[];
};

export const StudentSolutionSubContent: FC<StudentSolutionSubContentProps> = ({
  subContent,
  level,
  typeTree,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {subContent.map((scItem, scIndex) => {
        const solutionType = scItem?.type?.replace('H5P.', '') || 'Undefined';

        return (
          <React.Fragment key={scIndex}>
            {level === 0 && scIndex !== 0 && <StyledDivider />}
            {level === 0 && (
              <TopLevelQuestionType>
                {typeTree.map((type, index) => (
                  <React.Fragment key={index}>
                    {t(`trajectory.sections.shared.solutions.defaultQuestions.${type}`, {
                      defaultValue: t(
                        'trajectory.sections.shared.solutions.defaultQuestions.Undefined'
                      ),
                    })}
                    <TypeTreeDivider>&gt;</TypeTreeDivider>
                  </React.Fragment>
                ))}
                {t(`trajectory.sections.shared.solutions.defaultQuestions.${solutionType}`, {
                  defaultValue: t(
                    'trajectory.sections.shared.solutions.defaultQuestions.Undefined'
                  ),
                })}
              </TopLevelQuestionType>
            )}
            {level === 0 && scItem.question != null && (
              <MathJax>{ReactHtmlParser(preProcessLatex(scItem.question))}</MathJax>
            )}
            {scItem.subContent.length === 0 ? (
              <>
                {level !== 0 && (
                  <StyledQuestionTitle>
                    {t(`trajectory.sections.shared.solutions.defaultQuestions.${solutionType}`, {
                      defaultValue: t(
                        'trajectory.sections.shared.solutions.defaultQuestions.Undefined'
                      ),
                    })}
                  </StyledQuestionTitle>
                )}
                <div>{t('trajectory.sections.shared.solutions.noSolutions')}</div>
              </>
            ) : isSolutionWithSubContent(scItem.subContent[0]) ? (
              <StudentSolutionSubContent
                subContent={scItem.subContent as SolutionSubContent[]}
                level={level + 1}
                typeTree={[...typeTree, solutionType]}
              />
            ) : (
              <StudentSolutionSubContentAnswers
                subContentQuestion={scItem.question}
                answers={scItem.subContent as SolutionAnswer[]}
                type={solutionType}
                level={level}
              />
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};
